module.exports = function(value) {
	return JSON.parse(value);
};